// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3qMyn","label":"SetPasswdForm_label__1XyxA"};